import React from 'react';
import {Box, withStyles} from '@material-ui/core';
import {DropzoneArea} from 'material-ui-dropzone';
import {ValidatorComponent} from 'react-material-ui-form-validator';
import {styles} from './styles';

/**
 * class to render dropzone area validator
 * @returns {JSX.Element}
 */
class DropzoneAreaValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      value,
      errorMessages,
      validators,
      validatorListener,
      ...rest
    } = this.props;

    return (
      <Box>
        <DropzoneArea {...rest} />
        {this.errorText()}
      </Box>
    );
  }

  errorText() {
    const {isValid} = this.state;
    const {classes} = this.props;

    if (isValid) {
      return null;
    }

    return <Box className={classes.text}>{this.getErrorMessage()}</Box>;
  }
}

export default withStyles(styles)(DropzoneAreaValidator);
